import React from 'react';
import { node, string } from 'prop-types';
import classNames from 'classnames';
import { useLocation, useHistory } from 'react-router-dom';

import { useRouteConfiguration } from '../../../../context/routeConfigurationContext.js';
import { matchPathname } from '../../../../util/routes.js';

import { NamedLink, ExternalLink, Button } from '../../../../components/index.js';
import css from './Link.module.css';

const shouldRenderButton = path => {
  return ['/s/', '/l/new/'].includes(path);
};

export const Link = React.forwardRef((props, ref) => {
  const location = useLocation();
  const history = useHistory(); // <-- useHistory for v5
  const routes = useRouteConfiguration();

  const { className, rootClassName, href, title, children } = props;
  const isButton = shouldRenderButton(href);
  const classes = classNames(rootClassName || css.link, className);
  const titleMaybe = title ? { title } : {};
  const linkProps = { className: classes, href, children, ...titleMaybe };

  if (!href || !children) {
    return null;
  }

  if (href.charAt(0) === '/' && isButton) {
    // Render button that navigates internally

    return (
      <Button
        type="button"
        className={classNames(classes, css.buttonLink)}
        onClick={() => history.push(href)}
        {...titleMaybe}
        ref={ref}
      >
        {children}
      </Button>
    );
  } else if (href.charAt(0) === '/') {
    const testURL = new URL('http://my.marketplace.com' + href);
    const matchedRoutes = matchPathname(testURL.pathname, routes);
    if (matchedRoutes.length > 0) {
      const found = matchedRoutes[0];
      const to = { search: testURL.search, hash: testURL.hash };
      return (
        <NamedLink name={found.route.name} params={found.params} to={to} {...linkProps} ref={ref} />
      );
    }
  }

  if (href.charAt(0) === '#') {
    if (typeof window !== 'undefined') {
      const hash = href;
      const testURL = new URL(
        `http://my.marketplace.com${location.pathname}${location.hash}${location.search}`
      );
      testURL.hash = hash;
      const matchedRoutes = matchPathname(testURL.pathname, routes);
      if (matchedRoutes.length > 0) {
        const found = matchedRoutes[0];
        const to = { search: testURL.search, hash: testURL.hash };
        return (
          <NamedLink
            name={found.route.name}
            params={found.params}
            to={to}
            {...linkProps}
            ref={ref}
          />
        );
      }
    }
  }

  return <ExternalLink {...linkProps} ref={ref} />;
});

Link.displayName = 'Link';

Link.defaultProps = {
  rootClassName: null,
  className: null,
};

Link.propTypes = {
  rootClassName: string,
  className: string,
  children: node.isRequired,
  href: string.isRequired,
};
